// import json_parse from './json_parse'

//const coinApi = 'https://www.bitfeel.cn/'

const communityApi = process.env.NODE_ENV == 'production' ? "/community" : "/web3Community"
const newsApi = process.env.NODE_ENV == 'production' ? "/news" : "/higgsNews"
// 请求函数
export function myFetch(postdata, url = '', method) {
  // postdata = JSON.stringify(postdata);
  var params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin':"*",
      'Authorization': localStorage.getItem("githubToken")
    },
    redirect: 'follow',
    method: method || 'POST',
  }
  if ( method === 'POST' || !method) {
    params.body = postdata
  }
  if (method === 'GET' && postdata) {
    let queryArr = []
        // 过滤值为空字符串，null，undefined的参数
    Object.keys(postdata).filter(q => postdata[q] === 0 || postdata[q]).forEach(q => queryArr.push(`${q}=${postdata[q]}`))
        // console.log('queryArr', queryArr);
    url = `${url}?${queryArr.join('&')}`
    postdata = false
}

  return fetch(url, params)
  .then((res) => {
    var response = res
    if (response.status >= 200 && response.status < 300) {
      return response.json()
    } else {
      var error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }).catch((err) => {
  })
}



/* 接口部分 */
// 总类列表
export function getCategoryList(params) {
  let url = communityApi + '/api/sys/category/list'
  return myFetch(params, url,'GET')
}

// 查询jobList
export function getJobList(params) {
  let url = communityApi + '/api/sys/article/job/list'
  return myFetch(params, url,'GET')
}

// 查询job详情
export function getJobDetail(params) {
  let url = communityApi + '/api/sys/article/job/detail'
  return myFetch(params, url,'GET')
}

// 查询最新文章数据
// export function getArticleRecommend(params) {
//   let url = newsApi + '/api/tnv/articlerecommend/pageList'
//   return myFetch(params, url,'GET')
// }
export function getArticleRecommend(params) {
  let url = newsApi + '/api/tnv/articletop/top'
  return myFetch(params, url,'GET')
}

// 获取教程详情
export function getTutorialDetail(params) {
  let url = communityApi + '/api/sys/article/detail'
  return myFetch(params, url,'GET')
}


// 获取文章类别
export function getArticleCategory(params) {
  let url = newsApi + '/api/tnv/articlecategory/list'
  return myFetch(params, url,'GET')
}
// 获取文章
export function getArticles(params) {
  let url = newsApi + '/api/tnv/article/listWithPage'
  return myFetch(params, url,'GET')
}
// 获取文章详细信息
export function getArticleDetail(params) {
  let url = newsApi + '/api/tnv/article/info/'+ params.id
  return myFetch(params, url,'GET')
}


// Github第三方登录
export function getGithub(params) {
  let url = communityApi + '/api/sys/oauth'
  return myFetch(params, url,'GET')
}

// 推荐查询
export function getRecommendList(params) {
  let url = communityApi + '/api/sys/recommend/list'
  return myFetch(params, url,'GET')
}












